import Vue from 'vue'

export function setOrigenes(state, origenes) {
    state.origenes = origenes;
}

export function setOrigenSelec(state, origen) {
    state.origenSelec = origen;
}

export function actListOrigenes(state, origen) {
    if (origen !== null) {
        const index = state.origenes.findIndex(r => r.id === origen.id)
        if (index != -1) {
            state.origenes[index].nombre = origen.nombre;  
            state.origenes[index].nombre_fiscal = origen.nombre_fiscal;
            state.origenes[index].cif = origen.cif;
            state.origenes[index].descripcion = origen.descripcion;  
            state.origenes[index].responsable = origen.responsable;  
            state.origenes[index].telefono = origen.telefono;  
            state.origenes[index].telefono_2 = origen.telefono_2;
            state.origenes[index].email = origen.email;  
            state.origenes[index].identificador = origen.identificador;
            state.origenes[index].cod_proveedor = origen.cod_proveedor;
            state.origenes[index].comision = origen.comision;
            state.origenes[index].direccion = origen.direccion;
            state.origenes[index].cod_postal = origen.cod_postal;
            state.origenes[index].poblacion = origen.poblacion;
            state.origenes[index].provincia = origen.provincia;
            state.origenes[index].pais = origen.pais;
            state.origenes[index].direccion_fiscal = origen.direccion_fiscal;
            state.origenes[index].cod_postal_fiscal = origen.cod_postal_fiscal;
            state.origenes[index].poblacion_fiscal = origen.poblacion_fiscal;
            state.origenes[index].provincia_fiscal = origen.provincia_fiscal;
            state.origenes[index].pais_fiscal = origen.pais_fiscal;
            state.origenes[index].observacion = origen.observacion;
            state.origenes[index].mensaje = origen.mensaje;
            state.origenes[index].grupo_id = origen.grupo_id;  
            state.origenes[index].caminos_permitidos = origen.caminos_permitidos;
            Vue.set(state.origenes[index], 'is_active', origen.is_active);
            Vue.set(state.origenes[index], 'users', origen.users || []);
        }
    }
}

export function actDeleteListOrigenes(state, id) {
    if (id != null) {
        const index = state.origenes.findIndex(r => r.id === id)
        if (index != -1) {
            state.origenes.splice(index, 1)
        }
    }
}

export function actUserInOrigenes(state, payload) {
    if (!payload || payload.user_id == null) {
        return;
    }

    for (let i = 0; i < state.origenes.length; i++) {
        const usuarios = state.origenes[i].users;
        if (!Array.isArray(usuarios)) {
            continue;
        }

        const userIndex = usuarios.findIndex((user) => String(user.id) === String(payload.user_id));
        if (userIndex !== -1) {
            state.origenes[i].users[userIndex] = {
                ...state.origenes[i].users[userIndex],
                ...payload.user,
            };
            return;
        }
    }
}
